import { useState } from 'react';

export function useActivate(initialValue: boolean) {
  const [value, setValue] = useState(initialValue);

  const activate = (callback?: (newValue: boolean) => void) => {
    setValue(true);
    if (callback) {
      callback(true);
    }
  };

  const deactivate = (callback?: (newValue: boolean) => void) => {
    setValue(false);
    if (callback) {
      callback(false);
    }
  };

  return [value, activate, deactivate] as const;
}